// Library methods
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

// MUI Components
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";

// Styles
import {
  CustomTextFieldOutlined,
  CustomTextFieldOutlinedInputProps,
} from "../../../styles/muiStylesHelper";

// constants
const MIN_COLOR_LIMIT = 0;
const MAX_COLOR_LIMIT = 20;

const ExamCreationSettings = ({ currentSettings, handleUpdateSettings }) => {
  // internationalization
  const { t } = useTranslation();

  const colorVisionDefaultTimeLimit = useMemo(
    () => currentSettings?.colorVisionDefaultTimeLimit,
    [currentSettings?.colorVisionDefaultTimeLimit]
  );

  const onChangeValue = useCallback(
    (event) => {
      if (Number(event?.target?.value) > MAX_COLOR_LIMIT) {
        handleUpdateSettings({
          ...currentSettings,
          colorVisionDefaultTimeLimit: MAX_COLOR_LIMIT,
        });
      } else if (Number(event?.target?.value) < MIN_COLOR_LIMIT) {
        handleUpdateSettings({
          ...currentSettings,
          colorVisionDefaultTimeLimit: MIN_COLOR_LIMIT,
        });
      } else {
        handleUpdateSettings({
          ...currentSettings,
          colorVisionDefaultTimeLimit: event?.target?.value,
        });
      }
    },
    [currentSettings, handleUpdateSettings]
  );

  // user can only type a number that is different from the previous value
  const onKeyPress = useCallback(
    (event) => {
      const isNotNumber =
        event?.key === "-" || event?.key === "+" || event?.key === ".";
      const isSameValue =
        Number(event?.target?.value) === Number(colorVisionDefaultTimeLimit);

      if (isNotNumber || isSameValue) return;

      handleUpdateSettings({
        ...currentSettings,
        colorVisionDefaultTimeLimit: event?.target?.value,
      });
    },
    [colorVisionDefaultTimeLimit, currentSettings, handleUpdateSettings]
  );

  return (
    <Box display="flex" flexDirection="column" gap="8px">
      <Typography fontSize={{ xs: "18px", sm: "20px" }} fontWeight={600}>
        {t("settings_color_vision_time")}
      </Typography>
      <Typography fontSize="14px" mb="12px" color="#5B6D7A">
        {t("color_vision_time_limit")}
      </Typography>
      <FormControl sx={{ minWidth: "100%" }}>
        <TextField
          type="number"
          id="color vision exam default time input"
          value={colorVisionDefaultTimeLimit}
          onChange={onChangeValue}
          onKeyPress={onKeyPress}
          color="warning"
          label={t("settings_time_in_minutes")}
          variant="outlined"
          fullWidth
          sx={() =>
            CustomTextFieldOutlined({
              mt: 0,
              mr: 0,
              minWidth: "100%",
            })
          }
          InputProps={{
            inputProps: { min: MIN_COLOR_LIMIT, max: MAX_COLOR_LIMIT },
            sx: {
              ...CustomTextFieldOutlinedInputProps,
            },
          }}
        />
      </FormControl>
    </Box>
  );
};

export default ExamCreationSettings;
